/**
 * Spinner primitive — loading indicator with `role="status"` + sr-only label.
 * Ported from Play sc-marketing `ui/spinner.tsx` (translation log there).
 * When replacing a text-only loading state, ALWAYS pass the original string as
 * `label` verbatim (e.g. label="Loading…") so test queries keep matching.
 *
 * @example
 * <Spinner label="Loading…" />
 */
import { cn } from '../lib/cn';

interface SpinnerProps {
  /** Screen-reader label. Defaults to "Loading". */
  label?: string;
  className?: string;
}

export function Spinner({ label = 'Loading', className }: SpinnerProps) {
  return (
    <div className={cn('p-10 text-center text-fg-subtle', className)} role="status">
      <span
        className="inline-block w-5 h-5 rounded-full border-2 border-border border-t-fg-muted animate-spin"
        aria-hidden
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
